import { render, staticRenderFns } from "./WQuestionView.vue?vue&type=template&id=f39c0fe0&"
import script from "./WQuestionView.vue?vue&type=script&lang=ts&"
export * from "./WQuestionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports